const MS_PER_DAY = 1000 * 60 * 60 * 24;

export const todayISO = () => new Date().toISOString().slice(0, 10);

export function daysBetween(fromISO, toISO) {
  if (!fromISO || !toISO) return null;
  const from = new Date(fromISO);
  const to = new Date(toISO);
  if (Number.isNaN(from) || Number.isNaN(to)) return null;
  return Math.round((to - from) / MS_PER_DAY);
}

// Human readable age from a date of birth, relative to today.
export function ageFromDob(dob, reference = todayISO()) {
  const days = daysBetween(dob, reference);
  if (days == null || days < 0) return '—';
  if (days < 60) return `${days}d`;
  const months = Math.floor(days / 30.44);
  if (months < 24) return `${months} mo`;
  const years = Math.floor(months / 12);
  const remMonths = months % 12;
  return remMonths ? `${years}y ${remMonths}m` : `${years}y`;
}

// Average daily gain (kg/day) from an ordered-by-date weight list.
export function computeADG(weights) {
  if (!Array.isArray(weights) || weights.length < 2) return null;
  const sorted = [...weights].sort((a, b) => (a.date || '').localeCompare(b.date || ''));
  const first = sorted[0];
  const last = sorted[sorted.length - 1];
  const days = daysBetween(first.date, last.date);
  if (!days || days <= 0) return null;
  const overall = (Number(last.weight_kg) - Number(first.weight_kg)) / days;

  const prev = sorted[sorted.length - 2];
  const recentDays = daysBetween(prev.date, last.date);
  const recent = recentDays && recentDays > 0
    ? (Number(last.weight_kg) - Number(prev.weight_kg)) / recentDays
    : null;

  return { overall, recent, latest: Number(last.weight_kg) };
}

export const formatADG = (value) => (value == null ? '—' : `${(value * 1000).toFixed(0)} g/day`);

export const percent = (value) => (value == null ? '—' : `${Math.round(value * 100)}%`);
